import { Route, Routes } from "react-router-dom";
import { useEffect } from "react";

import styles from "./App.module.css";
import Questionare from "./screens/Questionare";
import { setDimensionsRatio } from "../constants/utils";

function WellbeingApp() {
  useEffect(() => {
    setDimensionsRatio();
  }, []);

  return (
    <div className={styles.App}>
      <Routes>
        <Route path="/" element={<Questionare />} />
      </Routes>
    </div>
  );
}

export default WellbeingApp;
